// extracted by mini-css-extract-plugin
module.exports = {"root":"FwvG7Nha"};